// extracted by css-extract-rspack-plugin
export default {"radio":"radio-mQunhR","item":"item-qhrzu6","vcfc":"vcfc-S7qdBm"};